
const m = window.require("discourse/helpers/avatar");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
